export const filterButtonStyles = theme => ({
  '&:first-of-type': {
    paddingTop: 0,
  },
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(2),
  width: '100%',
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(3),
    width: '100%',
  },
});

export const filterPopoverStyles = theme => ({
  margin: theme.spacing(2, 4),
  paddingTop: theme.spacing(2),
  width: '220px',
  [theme.breakpoints.down('lg')]: {
    margin: theme.spacing(2),
    width: 'calc(100% - 32px)',
  },
});
